import type { ReactNode } from 'react';

import { Parameter } from '../../Providers/GraphqlProvider/generated';
import LayoutConfigContext from './LayoutConfigContext';

export interface ILayoutConfig {
  layoutConfig: {
    parametersDefault?: Parameter[];
  };
}

type Props = {
  children: ReactNode | undefined;
  value: ILayoutConfig;
};

const LayoutConfigProvider = ({ children, value }: Props) => {
  return <LayoutConfigContext.Provider value={value}>{children}</LayoutConfigContext.Provider>;
};

export default LayoutConfigProvider;
